import { TagColorType } from 'components/tag/Tag';

import { RatingType } from './RatingTypes';
import { ServiceRequestType } from './ServiceRequestTypes';
import { TroubleshootingRequestType } from './TroubleshootingRequestTypes';

export type RefReturnType =
  | string
  | ((instance: HTMLInputElement | null) => void)
  | React.RefObject<HTMLInputElement>
  | null
  | undefined;

export interface RegisterType {
  max?: number;
  maxLength?: number;
  min?: number;
  minLength?: number;
  required?: boolean;
  validate?: (string) => boolean;
}

export interface StatusOptionType {
  color: TagColorType;
  tooltip: string;
  text: string;
}

export interface ConversionRatesTypes {
  AED: number;
  AUD: number;
  GBP: number;
  JPY: number;
  NOK: number;
  SGD: number;
  USD: number;
}

export enum CurrencyType {
  AED = 'AED',
  AUD = 'AUD',
  GBP = 'GBP',
  EUR = 'EUR',
  JPY = 'JPY',
  NOK = 'NOK',
  SGD = 'SGD',
  USD = 'USD',
}

export enum CurrencySymbolType {
  AED = 'د.إ',
  AUD = 'A$',
  GBP = '£',
  EUR = '€',
  JPY = '¥',
  NOK = 'kr',
  SGD = 'S$',
  USD = '$',
}

export interface ModalInfoType {
  request: TroubleshootingRequestType | ServiceRequestType;
  serviceRequestInfo?: Pick<ServiceRequestType, 'port' | 'eta' | 'etd'>;
  supplierInfo: {
    name: string;
    _id: string;
  };
  rating?: RatingType;
}
